import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Times } from '@resultadosdigitais/tangram-react-icons';
import DrawerTitle from './DrawerTitle';
import IconButton from '../IconButton';
var Root = styled.div.withConfig({
  displayName: "DrawerHeader__Root",
  componentId: "sc-16vzlfe-0"
})(["display:flex;align-items:center;padding:var(--size-spacing-05);border-bottom:1px solid var(--color-gray-20);height:max-content;"]);

var _ref =
/*#__PURE__*/
React.createElement(Times, {
  title: "close icon",
  titleId: "close-icon"
});

var DrawerHeader = function DrawerHeader(_ref2) {
  var dismissible = _ref2.dismissible,
      onDismiss = _ref2.onDismiss,
      text = _ref2.text,
      children = _ref2.children;
  return (
    /*#__PURE__*/
    React.createElement(Root, null, text &&
    /*#__PURE__*/
    React.createElement(DrawerTitle, null, text), children, dismissible &&
    /*#__PURE__*/
    React.createElement(IconButton, {
      onClick: onDismiss,
      kind: IconButton.kinds.tertiary
    }, _ref))
  );
};

DrawerHeader.defaultProps = {
  onDismiss: function onDismiss() {},
  dismissible: true,
  children: undefined,
  text: undefined
};
process.env.NODE_ENV !== "production" ? DrawerHeader.propTypes = {
  /**
   * Close icon click event.
   */
  onDismiss: PropTypes.func,

  /**
   * Toggles the close icon display.
   */
  dismissible: PropTypes.bool,

  /**
   * Displays the given text as a title.
   * You get the same result using `DrawerTitle` within children.
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /**
   * Compose the content between the title and the close icon.
   */
  children: PropTypes.node
} : void 0;
export default DrawerHeader;